var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.888,
    height: 270.463,
    viewBox: "0 0 229.888 270.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-save-4654488",
    transform: "translate(-235.051 -144.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M457.3,214.14l-46.449-57a33.818,33.818,0,0,0-26.371-12.375l-115.62,0a33.809,33.809,0,0,0-33.809,33.809v202.84a33.809,33.809,0,0,0,33.809,33.809H431.13a33.809,33.809,0,0,0,33.809-33.809V235.578a33.832,33.832,0,0,0-7.641-21.434ZM289.14,158.292h74.375v27.047a20.285,20.285,0,0,1-20.285,20.285H309.421a20.285,20.285,0,0,1-20.285-20.285Zm0,243.41V320.565a20.285,20.285,0,0,1,20.285-20.285h67.613a20.285,20.285,0,0,1,20.285,20.285V401.7Zm162.27-20.281a20.285,20.285,0,0,1-20.285,20.285H410.84V320.569a33.809,33.809,0,0,0-33.809-33.809H309.418a33.809,33.809,0,0,0-33.809,33.809v81.137h-6.762a20.285,20.285,0,0,1-20.285-20.285l0-202.84A20.285,20.285,0,0,1,268.851,158.3h6.762v27.047a33.809,33.809,0,0,0,33.809,33.809h33.809a33.809,33.809,0,0,0,33.809-33.809V158.3h7.438a20.288,20.288,0,0,1,15.754,7.438l46.586,57a20.289,20.289,0,0,1,4.6,12.848Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.589fe26f6da3e5a0dff8db567b20409a.svg";
export { ForwardRef as ReactComponent };